export default "/_next/static/videos/1f426f0ef362c87588a2a3adaf97b602.mp4";